import { render, staticRenderFns } from "./DoctorLogModal.vue?vue&type=template&id=177272e4&"
import script from "./DoctorLogModal.vue?vue&type=script&lang=js&"
export * from "./DoctorLogModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports